export const SEARCH_EVENTS_REQUEST = '@event/SEARCH_EVENTS_REQUEST';
export const SEARCH_EVENTS_FAILURE = '@event/SEARCH_EVENTS_FAILURE';
export const SEARCH_EVENTS_SUCCESS = '@event/SEARCH_EVENTS_SUCCESS';
